import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0C0E] text-[#F5F3EE] flex items-center justify-center p-6">
      <div className="card-surface p-10 max-w-lg w-full text-center" data-testid="payment-cancel-card">
        <div className="overline mb-3">Cancelled</div>
        <h1 className="font-display text-4xl leading-none mb-4">No charge made.</h1>
        <p className="text-[#A8ADA5] mb-8">
          You cancelled the checkout. No card was billed. Your free tier is unchanged.
        </p>
        <div className="flex gap-3 justify-center">
          <Link to="/app/pricing">
            <Button className="rounded-full btn-lime">
              Back to pricing <ArrowUpRight size={15} className="ml-1.5" />
            </Button>
          </Link>
          <Link to="/app">
            <Button className="rounded-full btn-outline">Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
